import {RestrictedRouteModuleConfiguration} from "modules/router/model/UserPermission";
import {AngularJsMaterialModuleName, UtilsModuleName} from "modules/utils/names/requiredModulesNames";

export const UtilsModule = new RestrictedRouteModuleConfiguration(UtilsModuleName,
    [
        AngularJsMaterialModuleName
    ],
    [],
    [],
    [],
    []
);